import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { CareerPlanLevel, CareerPlanSkillDetail } from 'src/app/models/career-plans';

@Component({
  selector: 'app-skill-detail',
  templateUrl: './skill-detail.component.html',
  styleUrls: ['./skill-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillDetailComponent implements OnChanges {
  @Input()
  skillDetail: CareerPlanSkillDetail;
  firstLevelInProgress: CareerPlanLevel;

  ngOnChanges() {
    this.retrieveFirstLevelInProgress();
  }

  private retrieveFirstLevelInProgress() {
    this.firstLevelInProgress = this.skillDetail.levels.filter(
      (level) => !level.locked && level.resourcesCompleted < level.resourcesTotal
    )[0];
  }
}
